<mat-form-field
  subscriptSizing="dynamic"
  class="w-full [--mat-form-field-container-text-size:14px] [--mat-form-field-container-height:48px] [--mat-form-field-container-vertical-padding:12px]"
>
  <mat-icon matPrefix>label</mat-icon>

  <mat-select
    class="[--mat-select-trigger-text-size:14px]"
    multiple
    placeholder="Tags"
    panelClass="tag-filter-panel"
    [panelWidth]="panelWidth()"
    [disabled]="disabled()"
    [ngModel]="selectedTagIds()"
    (ngModelChange)="handleSelectionChange($event)"
    (openedChange)="handlePanelOpenedChange($event)"
  >
    <mat-select-trigger>
      @if (triggerLabel(); as label) {
        {{ label }}
      } @else {
        Kies tags
      }
    </mat-select-trigger>

    <div class="tag-search-header flex items-center text-gray-700">
      <mat-icon class="absolute pointer-events-none">search</mat-icon>
      <input
        #searchInput
        class="tag-search-input"
        type="text"
        placeholder="Zoek tag..."
        autocomplete="off"
        [value]="searchTerm()"
        (input)="searchTerm.set(searchInput.value)"
        (keydown)="stopPropagation($event)"
      />
    </div>

    @for (tag of filteredTags(); track tag.id) {
      <mat-option [value]="tag.id" class="[--mat-option-label-text-size:14px]">{{ tag.label }}</mat-option>
    } @empty {
      <mat-option disabled>Geen tags gevonden</mat-option>
    }
  </mat-select>
</mat-form-field>
